import React from 'react'
import { ViewCommonProps, Year as YearProps } from '../../types';
import Month from './month';
import styles from './base-calendar.module.scss';
import classNames from 'classnames';

interface YearRendererProps extends ViewCommonProps {
    year?: YearProps;
    showHeader?: boolean
}

export default function Year(props: YearRendererProps) {
    const { year, activeDate, showHeader } = props;
    const renderMonths = () => {
        return Array.from({ length: 12 }, (_, i) => i).map((m) => {
            const monthDate = activeDate.clone().set('month', m).startOf('day');
            const month = year?.months.find(x => x.id === monthDate.month() + 1);
            return (<Month
                month={month}
                key={monthDate.unix()}
                showHeader={showHeader}
                {...props} activeDate={monthDate} 
                fullFlex/>)
        })
    }

    return <div className={styles.monthsGrid}>{renderMonths()}</div>
}